import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { getStatusMeta, SEVERITY_META } from "./statusColors";
import { FILTER_FONT_SIZE } from "./filterBarStyles";

const badgeSx = ({ bg, fg, border, size, outlined }) => ({
  backgroundColor: outlined ? "transparent" : bg,
  color: fg,
  border: outlined ? `1px dashed ${border || fg}` : `1px solid ${border || fg}`,
  fontWeight: outlined ? 500 : 600,
  fontSize: size === "small" ? 12 : FILTER_FONT_SIZE,
  height: size === "small" ? 24 : 28,
  borderRadius: "6px",
  boxShadow: "none",
  "& .MuiChip-label": {
    px: 1,
    lineHeight: 1.2,
  },
});

export const StatusChip = ({ status, withTooltip = true, size = "small", sx = {} }) => {
  const meta = getStatusMeta(status);
  const chip = (
    <Chip
      size={size}
      label={meta.label}
      sx={{ ...badgeSx({ ...meta, size }), ...sx }}
    />
  );
  if (!withTooltip) return chip;
  return (
    <Tooltip title={meta.description} arrow>
      <span>{chip}</span>
    </Tooltip>
  );
};

export const SeverityChip = ({ severity, size = "small", sx = {} }) => {
  const s = (severity || "").toUpperCase();
  const meta = SEVERITY_META[s] || { bg: "#f1f5f9", fg: "#64748b", border: "#e2e8f0" };
  return (
    <Chip
      size={size}
      label={s || "—"}
      sx={{ ...badgeSx({ ...meta, size }), ...sx }}
    />
  );
};

export default StatusChip;
